export const SUCESS = "SUCCESS";
export const ERROR = "ERROR";
export const MAP_CENTER: any = [-23.089096, -47.212495];
